import blankshield from 'blankshield';

const initBlankshield = () => {
  /**
   * blankshield - Prevent reverse tabnabbing phishing attacks caused by _blank
   *
   * @version   0.6.0
   * @link      https://github.com/danielstjules/blankshield
   * @author    Daniel St. Jules <danielst.jules@gmail.com>
   * @license   MIT
   */
  document.addEventListener('DOMContentLoaded', () => {
    blankshield(document.querySelectorAll('a[target=_blank]'));
  });
};

export default initBlankshield;
